/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { AssetUtils, Channel } from '@wit/vtv-x-foundation-lib';
import { StoreState } from 'store/store';
import { ActionTypes, Actions } from './channels';

export interface ReducerState {
  data?: Channel[];
}

const initialState: ReducerState = {};

export default function channelsReducer(state = initialState, action: Actions): ReducerState {
  switch (action.type) {
    case ActionTypes.SUCCESS: {
      return {
        data: action.payload.filter(AssetUtils.isPlayableChannel),
      };
    }
    default:
      return state;
  }
}

// SELECTORS

export const Selectors = {
  getChannels: (state: StoreState): Channel[] | undefined => {
    return state.playableChannels?.data;
  },
  getChannelByEpgId: (state: StoreState, epgId: number): Channel | undefined => {
    return state.playableChannels?.data?.find((channel) => channel.epgId === epgId);
  },
};
